import axios from '@/plugins/axios'
import { Module } from 'vuex'

const workspaceSettings: Module<any, any> = {
    state: {
        invoiceRecipients: [],
    },
    actions: {
        async getWorkspaceSettings(_, workspaceId) {
            const { data } = await axios.get(
                '/api/workspaces/' + workspaceId + '/settings',
            )

            return data
        },
        async updateWorkspaceSettings(_, params) {
            const { data } = await axios.put(
                `/api/workspaces/${params.id}/settings`,
                params,
            )

            return data
        },
        async getCustomer(_, customerId) {
            const { data } = await axios.get('/api/customers/' + customerId)
            return data
        },
        async updateCustomer(_, params) {
            const { data } = await axios.put(
                '/api/customers/' + params.id,
                params,
            )

            return data
        },
        async getInvoiceRecipients() {            
            const { data } = await axios.get('/api/invoice_recipients')
            return data
        },
        async addInvoiceRecipient(_, params) {
            await axios.post('/api/invoice_recipients', params)
        },
        async deleteInvoiceRecipient(_, id) {
            await axios.delete(`/api/invoice_recipients/${id}`)
        },
        async getPaymentMethods() {
            const { data } = await axios.get('/api/billing/payment_methods', {
                cache: false,
            })
            return data.items
        },
        async createSetupIntent() {
            const { data } = await axios.post('/api/billing/setup_intent')
            return data.clientSecret
        },
        async setDefaultPaymentMethod(_, id) {
            await axios.put(`/api/billing/payment_methods/${id}/default`)
        },
        // Overrides every current member's auto-pilot. `confirmation` is the
        // phrase the user typed: 'TURN-ON' or 'TURN-OFF'.
        async applyAutopilotToAllMembers(_, confirmation) {
            const { data } = await axios.post('/api/workspace_autopilot/apply_all', {
                confirmation,
            })
            return data
        },
    },
}

export default workspaceSettings
